import React from 'react';
import { ModalEnum } from '@uplift/types';
import { useStore } from '@uplift/hooks';
import { observer } from 'mobx-react-lite';
import { PatientCancelSessionModal } from '@uplift/ui-v2';
import { CalendarDateService } from '@uplift/services';

type ScheduleModalsProps = {
  refetchAppointments?: () => void;
  patientId: string;
};

export const ScheduleModals = observer<ScheduleModalsProps>(({ refetchAppointments, patientId }) => {
  const { modalStore } = useStore();
  // TODO fairly certian reschedule request is not used

  const fromDatetime = React.useMemo(() => {
    return CalendarDateService.date(modalStore.data?.appointment?.fromDatetime).utc().format();
  }, [ modalStore.data?.appointment?.fromDatetime ]);

  return (
    modalStore.isVisible(ModalEnum.cancelSession) && (
      <PatientCancelSessionModal
        open
        providerName={modalStore?.data?.appointment?.providerName.first}
        appointmentId={modalStore.data?.appointment?.id}
        fromDatetime={fromDatetime}
        cancelMode={modalStore.data?.cancelMode}
        parentId={modalStore.data?.appointment?.parentId}
        isMaterialized={modalStore.data?.appointment?.isMaterialized}
        onSubmit={async () => {
          refetchAppointments?.();
        }}
        onClose={() => modalStore.closeModal(ModalEnum.cancelSession)}
        patientId={patientId}
      />
    )
  );
});
